import { render, staticRenderFns } from "./AllTeam.vue?vue&type=template&id=13a624a8&scoped=true&"
import script from "./AllTeam.vue?vue&type=script&lang=js&"
export * from "./AllTeam.vue?vue&type=script&lang=js&"
import style0 from "./AllTeam.vue?vue&type=style&index=0&id=13a624a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a624a8",
  null
  
)

export default component.exports